import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const deleteBusRoute = ({ courseId, routeId }) => {
  return api.delete(`admin/bus-courses-v2/${courseId}/routes/${routeId}`);
};

export const useDeleteBusRouteMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: deleteBusRoute,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries();
    },
    ...restConfig,
  });
};
